<template>
  <div class="col-sm-4 my-4">
    <div class="card">
      <img class="card-img-top" v-if="feature.image.path" :src="`/${feature.image.path.slice(5)}`"
           alt="">
      <div class="card-body">
        <h4 class="card-title">{{feature.title}}</h4>
        <p class="card-text">
          {{feature.text}}
        </p>
      </div>
      <div class="card-footer">
        <router-link :to="feature.buttonLink" class="btn btn-outline-primary">
          {{ feature.buttonText}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FeatureItem',
  props: {
    feature: Object,
  },
};
</script>

<style scoped>

</style>
